import { FlowStepActionFunction } from '../flow-engine';
import history from '../../routing/BrowserHistory';
import { APIContextActions } from '../../api/APIContext';

export const action: FlowStepActionFunction = function useAction(_apiActions: APIContextActions): void {
  history.replace('/welcome');
};
